// User pref key sent to BE to update the user's preference on whether to show crossflow Ads or not.
export const CROSSFLOW_AD_DISMISSED_USER_PREF_KEY =
	'jira.user.issue.details.crossflow-banner.dismissed';
